import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-69">
      <div className="mb-12" data-id="element-70">
        <h2 className="text-2xl font-bold text-zinc-400 mb-6 flex items-center justify-center gap-2" data-id="element-71">
          <span data-id="element-72">⏰</span> EL PRECIO CIERRA EN:
        </h2>
        <Countdown data-id="element-73" />
      </div>

      <div className="space-y-6 mb-16" data-id="element-74">
        {/* Card 1 */}
        <div className="bg-surface border border-zinc-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 text-left" data-id="element-75">
          <div data-id="element-76">
            <h3 className="text-xl font-bold mb-1 flex items-center gap-2" data-id="element-77">
              <span data-id="element-78">📘</span> COMBO COMPLETO DE E. FUNCIONAL
            </h3>
            <p className="text-zinc-400 text-sm mb-4" data-id="element-79">
              6 Tomos + 6 Bonos · Sistema Anual Completo
            </p>
            <div className="flex items-end gap-3" data-id="element-80">
              <span className="text-zinc-500 line-through font-bold" data-id="element-81">
                $51.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-82">
                $19.990 <span className="text-lg text-zinc-400" data-id="element-83">ARS</span>
              </span>
            </div>
          </div>
          <Button href="https://www.compradigitalya.com/checkouts/cn/hWNBfCDdHQUTNK8tIikCUts2/es-ar?_r=AQAB1bvEcqlGPcyGyamgvjBgxYvtyuUNQZ9h35zPIFBVk78&cart_link_id=nZEWN4Xd&preview_theme_id=141062045767" className="w-full md:w-auto whitespace-nowrap" data-id="element-84">
            → QUIERO MI COMBO COMPLETO
          </Button>
        </div>

        {/* Card 2 */}
        <div className="bg-surface border-2 border-primary rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 text-left shadow-[0_0_30px_rgba(74,222,128,0.1)]" data-id="element-85">
          <div data-id="element-86">
            <h3 className="text-xl font-bold mb-1 flex items-center gap-2" data-id="element-87">
              <span data-id="element-88">🏆</span> COMBO COMPLETO + MÉTODO PROFE EMPRESARIO ⭐
            </h3>
            <p className="text-zinc-400 text-sm mb-4" data-id="element-89">
              6 Tomos + 6 Bonos + Negocio Rentable
            </p>
            <div className="flex items-end gap-3" data-id="element-90">
              <span className="text-zinc-500 line-through font-bold" data-id="element-91">
                $76.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-92">
                $27.990 <span className="text-lg text-zinc-400" data-id="element-93">ARS</span>
              </span>
            </div>
          </div>
          <Button href="https://www.compradigitalya.com/checkouts/cn/hWNBdUFFymDYbXpYXXycWa3O/es-ar?_r=AQAB9ZpcoTmOvmIKllCe542nTswrOhwYIuaMfsTG0ScpiM8&cart_link_id=S2jicxQP&preview_theme_id=141062045767" className="w-full md:w-auto whitespace-nowrap shadow-[0_0_20px_rgba(74,222,128,0.3)]" data-id="element-94">
            → QUIERO EL COMBO + NEGOCIO
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-sm text-zinc-400 font-medium mb-12" data-id="element-95">
        <span className="flex items-center gap-2" data-id="element-96">🔒 Pago 100% seguro</span>
        <span className="flex items-center gap-2" data-id="element-97">⚡ Acceso en 5 minutos</span>
        <span className="flex items-center gap-2" data-id="element-98">🛡️ Garantía 7 días</span>
        <span className="flex items-center gap-2" data-id="element-99">
          💳 Mercado Pago · Tarjeta · Transferencia
        </span>
      </div>
    </section>;
}